import React from "react";
import {TextField} from "@mui/material";
import {RankField} from "../fields";
import {forms, objects} from "@atttomyx/shared-utils";
import {sortingUtils} from "../../utils";

const VideoForm = (props) => {
    const { showRanks, showOrder, data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = modified.title && modified.youTubeId
            && (!showRanks || (modified.ranks && modified.ranks.length > 0))
            && (!showOrder || sortingUtils.isSortable(modified.order));

        onSync(modified);
    };

    return <div className="video-form">
        <div className="field top-margin">
            <TextField
                required={true}
                label="Name"
                type="text"
                value={forms.sanitizeValue(data.title)}
                onChange={(event) => onChange("title", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                required={true}
                label="YouTube Id"
                type="text"
                value={forms.sanitizeValue(data.youTubeId)}
                onChange={(event) => onChange("youTubeId", event.target.value)}
            />
        </div>
        {showRanks ?
            <div className="field">
                <RankField
                    value={forms.sanitizeValue(data.ranks)}
                    onChange={(value) => onChange("ranks", value)}
                />
            </div> : null}
        {showOrder ?
            <div className="field">
                <TextField
                    required={true}
                    label="Index"
                    type="number"
                    value={forms.sanitizeValue(data.order)}
                    onChange={(event) => onChange("order", event.target.value)}
                    inputProps={{
                        step: 1,
                        min: 0,
                    }}
                />
            </div> : null}
    </div>
}

export default VideoForm;
